import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { Color, Colors } from '~/assets/style/colors'

export type ServerSideDimensions = Extract<Dimension, 'tagId' | 'adUnit' | 'bidder'> | 'overview'

export const SERVER_SIDE_GENERAL_COLOR = {
  Others: Colors.SlateGrey,
}

export const SERVER_SIDE_DIMENSION_COLORS: {
  [key in ServerSideDimensions]: { [value: string | number]: Color }
} = {
  overview: {
    'Prebid Server': Colors.Midnight,
  },
  tagId: {
    0: Colors.Turquoise,
    1: Colors.Frog,
    2: Colors.Forest,
    3: Colors.Lava,
    4: Colors.Sun,
    5: Colors.Grass,
    6: Colors.Brick,
    7: Colors.Gold,
    8: Colors.SteelBlue,
    9: Colors.Kaiminus,
  },
  adUnit: {
    0: Colors.Sun,
    1: Colors.Salmon,
    2: Colors.Gold,
    3: Colors.Brick,
    4: Colors.Chocolate,
    5: Colors.Grass,
    6: Colors.Lilac,
    7: Colors.Forest,
    8: Colors.Milka,
    9: Colors.Midnight,
  },
  bidder: {
    0: Colors.Milka,
    1: Colors.Rose,
    2: Colors.Grass,
    3: Colors.Lilac,
    4: Colors.Violet,
    5: Colors.Gold,
    6: Colors.Kaiminus,
    7: Colors.Midnight,
    8: Colors.Forest,
    9: Colors.Sun,
  },
}
